import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslations } from "next-intl";
import { Runtime } from "@silvertours/front-entities";
import { LogoWrapper } from "./Logo.styles";
var Logo = function() {
    var ref = Runtime.useHost(), baseUrl = ref.baseUrl, baseImageUrl = ref.baseImageUrl;
    var t = useTranslations("features.stageLegacy.stage.searchForm");
    return /*#__PURE__*/ _jsxs(LogoWrapper, {
        children: [
            /*#__PURE__*/ _jsx("span", {
                children: t("widget.poweredBy")
            }),
            /*#__PURE__*/ _jsx("a", {
                href: "".concat(baseUrl, "/"),
                target: "_blank",
                rel: "noopener noreferrer nofollow",
                children: /*#__PURE__*/ _jsx("img", {
                    src: "".concat(baseImageUrl).concat(t("widget.logo.src")),
                    alt: t("widget.logo.alt"),
                    title: t("widget.logo.title"),
                    loading: "lazy"
                })
            })
        ]
    });
};
export { Logo };
